// services/registerUser.js
import { API_END_POINTS } from "../../API_END_POINTS";
import axios from "axios";

const addToCartUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.addToCart}`;
const updateCartUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.updateCart}`;
const showCartUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.getCart}`;
const getCartCountUrl = `${process.env.REACT_APP_API_URL}${API_END_POINTS.getCartCount}`;

const addToCartService = async ({ product_id, combinations }) => {
  try {
    const response = await axios.post(
      addToCartUrl,
      { product_id, combinations }, // Include variants in the request body
      {
        headers: {
          authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );
    return response.data; // Return the response for further handling
  } catch (error) {
    console.error("Error adding product to cart:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};

const updateCartService = async (product_id, quantity) => {
  const authToken = localStorage.getItem("authToken");
  if (!authToken) {
    console.error("No auth token found, unable to update cart.");
    throw new Error("Authentication token missing");
  }

  const productData = { product_id, quantity };

  try {
    const response = await axios.post(updateCartUrl, productData, {
      headers: {
        Authorization: `Bearer ${authToken}`, // Ensure proper capitalization
      },
    });

    return response.data; // Return response for Redux
  } catch (error) {
    console.error(
      "Error updating product quantity:",
      error.response?.data || error.message
    );
    throw error; // Ensure error is thrown for rejection in Redux thunk
  }
};

const getCartService = async ({ lang, couponCode }) => {
  const authToken = localStorage.getItem("authToken");
  try {
    const requestBody = couponCode ? { coupon_code: couponCode } : {}; // Include coupon if it exists

    const response = await axios.post(showCartUrl, requestBody, {
      headers: {
        authorization: `Bearer ${authToken}`,
        lang: lang || localStorage.getItem("language"),
      },
    });
    return response.data; // Return the cart data
  } catch (error) {
    console.error("Error fetching cart:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};

const getCartCountService = async () => {
  try {
    const response = await axios.get(getCartCountUrl, {
      headers: {
        authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    });
    return response.data; // Return the cart item count
  } catch (error) {
    console.error("Error fetching cart count:", error);
    throw error; // Throw the error for rejection in the async thunk
  }
};

export {
  addToCartService,
  getCartService,
  getCartCountService,
  updateCartService,
};
